import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box, Button, Grid, Divider } from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import data from "../data/April_16_Test_Result.json";
import { useNavigate } from "react-router-dom";

const Download = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [phoneNumberError, setPhoneNumberError] = React.useState(false);
  const [dateOfbirth, setDateOfBirth] = React.useState("");
  const [dateOfbirthError, setDateOfBirthError] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setPhoneNumberError(true);
    setDateOfBirthError(true);

    data.forEach((d) => {
      if (d.phNo === phoneNumber && d.dob === dateOfbirth) {
        setPhoneNumberError(false);
        setDateOfBirthError(false);
        console.log("Phone Number ::: " + phoneNumber);
        console.log("dateOfbirth ::: " + dateOfbirth);
        const path = "/result/"+phoneNumber + "/"+dateOfbirth;
        navigate(path);
      }
    });
  };
  return (
    <Container
      sx={{
        marginTop: "100px",
        marginBottom: "25px",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5">16-April-2023 Test Result.</Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Click on "Check Your Result" Button To Check Your Result.
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={{ flexGrow: 0 }}>
            <Button
              variant="contained"
              color="bgButtonPrimary"
              sx={{
                p: 1.5,
                fontWeight: "800",
              }}
              onClick={handleClickOpen}
            >
              Check Your Result
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Divider
        sx={{ height: "2px", backgroundColor: "#665b5b", marginTop: "20px" }}
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: "primary.main" }}>
          <Typography variant="h5">Check Result</Typography>
          <Divider
            sx={{
              height: "2px",
              backgroundColor: "#665b5b",
              marginTop: "20px",
            }}
          />
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "primary.main" }}>
          <DialogContentText sx={{ mb: 3 }}>
            <Typography variant="body2">
              Please Enter Your Registered Phone Number and Date of Birth.
            </Typography>
          </DialogContentText>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Enter Your Registerd Phone Number :-
          </Typography>
          <TextField
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            name="phone"
            autoFocus
            margin="normal"
            variant="outlined"
            fullWidth
            type="text"
            placeholder="xxxxx xxxxx"
            sx={{
              backgroundColor: "primary.main",
              borderRadius: "5px",
              border: "2px solid",
              borderColor: "borderColor.main",
              "& input": {
                color: "borderColor.main",
              },
            }}
          />
          {phoneNumberError && (
            <Typography
              variant="subtitle1"
              sx={{ color: "red", fontWeight: "600" }}
            >
              Phone Number is Invalid.
            </Typography>
          )}
          <Typography variant="body1" sx={{ mt: 1 }}>
            Enter Your Date Of Birth :-
          </Typography>
          <TextField
            value={dateOfbirth}
            onChange={(e) => setDateOfBirth(e.target.value)}
            name="dob"
            autoFocus
            margin="normal"
            type="date"
            fullWidth
            variant="outlined"
            placeholder="Date of Birth"
            sx={{
              backgroundColor: "primary.main",
              borderRadius: "5px",
              border: "2px solid",
              borderColor: "borderColor.main",
              "& input": {
                color: "borderColor.main",
              },
            }}
          />
          {dateOfbirthError && (
            <Typography
              variant="subtitle1"
              sx={{ color: "red", fontWeight: "600" }}
            >
              Date Of Birth is Invalid
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "primary.main" }}>
          <Button
            variant="contained"
            sx={{
              p: 1.5,
              fontWeight: "800",
              backgroundColor: "#ff0000a1",
              "&:hover": {
                backgroundColor: "#ff0000c9",
              },
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="bgButtonPrimary"
            sx={{
              p: 1.5,
              fontWeight: "800",
            }}
            onClick={handleSubmit}
          >
            Check
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Download;
